import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import dy from "./Dy.module.css";
import img from "../../img/img28.png";
import { fetchAllPosts, imageUrl } from "../../Api/PostManApi";

const Dynamic = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getPosts = async () => {
      setLoading(true);
      const data = await fetchAllPosts();
      setPosts(data.slice(0, 7));
      setLoading(false);
    };

    getPosts();
  }, []);

  return (
    <div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          <div className={dy.dy}>
            <div className={dy.container}>
              <div className={dy.content}>
                <h4>Latest news</h4>
                <ul>
                  {posts.map((post) => (
                    <li key={post._id}>
                      <Link to={`/${post?.slug}`}>
                        <img
                          src={`${imageUrl}/post_images/${post?.images}`}
                          alt={post.title || "Post image"} // Always good to have proper alt text
                        />
                        <h3>{post.title}</h3>
                        <p>{post.description.substring(0, 100)}...</p>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dynamic;
